import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table = ({ tavanmadihaScore, setTavanmadihaScore, reload }) => {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)


  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.majmooeTavanmadiha;
    if (items) {
      const tavanmadiha = items[Object.keys(items)[0]];
      const tavanmadihaData = [
        { name: "مهارتهای ساده", score: 6, isSelected: tavanmadiha.value == 0 },
        { name: "مهارتهای نسبتا ساده", score: 12, isSelected: tavanmadiha.value == 1 },
        { name: "مهارتهای نسبتا پیچیده", score: 18, isSelected: tavanmadiha.value == 2 },
        { name: "مهارتهای پیچیده", score: 24, isSelected: tavanmadiha.value == 3 },
        { name: "مهارتهای خیلی پیچیده", score: 30, isSelected: tavanmadiha.value == 4 },

      ]

      const selectedItem = tavanmadihaData.find((i) => i.isSelected)?.score
      setTavanmadihaScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "majmooeTavanmadiha": selectedItem }))
    }
  }, [reload])





  return (


    <div>
      <Row type={1}>
        <Column>مهارتهای ساده</Column>
        <Column>مهارتهای نسبتاً ساده</Column>
        <Column>مهارتهای نسبتاً پیچیده</Column>
        <Column>مهارتهای پیچیده</Column>
        <Column>مهارتهای خیلی پیچیده</Column>
      </Row>
      <Row>
        <Column isActive={tavanmadihaScore == 6}>6</Column>
        <Column isActive={tavanmadihaScore == 12}>12</Column>
        <Column isActive={tavanmadihaScore == 18}>18</Column>
        <Column isActive={tavanmadihaScore == 24}>24</Column>
        <Column isActive={tavanmadihaScore == 30}>30</Column>
      </Row>
    </div>
  );
};

export default Table;
